import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // localStorage

const initialState = {
  isLoading: false,
  error: "",
  forgetPasswordInfo: {},
  loggedInUser: {},
  walletBalance: 0,
};

export const AuthSlice = createSlice({
  name: "Auth",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload;
    },
    openLoader: (state, action) => {
      state.isLoading = true;
    },
    closeLoader: (state, action) => {
      state.isLoading = false;
    },
    setLoggedInUserInfo: (state, action) => {
      state.loggedInUser = { ...action.payload };
    },
    clearLoggedInUser: (state, action) => {
      localStorage.clear();
      sessionStorage.clear();

      storage.removeItem("persist:root");
      storage.removeItem("persist:auth");
      // window.location.reload();
      return { ...initialState };
    },
    setForgetPasswordInfo: (state, action) => {
      const { email, type, token } = action.payload;
      state.forgetPasswordInfo = {
        ...state.forgetPasswordInfo,
        email,
        type,
        token,
      };
    },
    setWalletBalance: (state, action) => {
      state.walletBalance = action.payload;
    },
  },
});

export const { clearLoggedInUser, setWalletBalance, openLoader, closeLoader } =
  AuthSlice.actions;
export default AuthSlice.reducer;
